import ArticleLayout from "@/components/feature/ArticleLayout";
import { newArticles } from "@/mocks/articles";

export default function GuiaIniciantesHoobuy() {
  return <ArticleLayout article={newArticles[0]} />;
}